import checkJwt from './../../../Global/jwtChecker' 
import logout from './../../../Global/logout' 
import Excel from 'exceljs'
import {saveAs} from "file-saver";
import moment from 'moment'

// eslint-disable-next-line import/no-anonymous-default-export
export default async function(data, startDate, endDate) {
    const unHashedJwt = checkJwt()    

    if(!unHashedJwt){
        logout()
    }

    const border =  {
        top: {style:'thin'},
        left: {style:'thin'},
        bottom: {style:'thin'},
        right: {style:'thin'}
      };

    const alignment = { vertical: 'top', horizontal: 'center', wrapText: true };

    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Izvjestaj", {
        pageSetup:{fitToPage: true, fitToHeight: 5, fitToWidth: 7}});   
    const options = {
        dateFormats: ['DD.MM.YYYY HH:mm:ss']
      };

    // pre header
    worksheet.mergeCells('A1', 'W1');
    worksheet.getCell('A1').font = { bold: true }   
    worksheet.getCell('A1').value = 'REKAPITULACIJA PROMETA'    
    worksheet.mergeCells('A3', 'W3');  
    worksheet.getCell('A3').value = 'Datum od: ' + moment(startDate).format("DD.MM.YYYY")
    worksheet.mergeCells('A4', 'W4');
    worksheet.getCell('A4').value = 'Datum do: ' + moment(endDate).format("DD.MM.YYYY") 

    // header
    worksheet.getCell('A6').value = 'R.br.';
    worksheet.mergeCells('A6', 'A8');  
    worksheet.getCell('B6').value = 'RAČUN';
    worksheet.getCell('B7').value = 'Broj';
    worksheet.mergeCells('B7', 'B8'); 
    worksheet.getCell('C7').value = 'Datum';
    worksheet.mergeCells('C7', 'C8'); 
    worksheet.getCell('D6').value = 'Kupac';
    worksheet.mergeCells('D6', 'H6'); 
    worksheet.getCell('D7').value = 'ID koirsnika';
    worksheet.mergeCells('D7', 'D8'); 
    worksheet.getCell('E7').value = 'Naziv'
    worksheet.mergeCells('E7', 'E8'); 
    worksheet.getCell('F7').value = 'Adresa'
    worksheet.mergeCells('F7', 'F8'); 
    worksheet.getCell('G7').value = 'Zemlja'
    worksheet.mergeCells('G7', 'G8'); 
    worksheet.getCell('H7').value = 'PDV ID BR/OIB';
    worksheet.mergeCells('H7', 'H8'); 
    worksheet.getCell('I6').value = 'Iznos ukupno u valuti dokumenta';
    worksheet.mergeCells('I6', 'I8');
    worksheet.getCell('J6').value = 'Valuta dokumenta';
    worksheet.mergeCells('J6', 'J8');
    worksheet.getCell('K6').value = 'Iznos ukupno u EUR';
    worksheet.mergeCells('K6', 'K8');
    worksheet.getCell('L6').value = 'Ne podliježe oporezivanju i oslobođeno pdv-a';
    worksheet.mergeCells('L6', 'N6');
    worksheet.getCell('L7').value = 'Obavljene usluge unutar EU';
    worksheet.mergeCells('L7', 'L8');
    worksheet.getCell('M7').value = 'Obavljene isporuke osobama bez sjedišta u RH';
    worksheet.mergeCells('M7', 'M8');
    worksheet.getCell('N7').value = 'Izvozne isporuke';
    worksheet.mergeCells('N7', 'N8');

    worksheet.getCell('O6').value = 'Oporezivo';
    worksheet.mergeCells('O6', 'P6');
    worksheet.getCell('O7').value = '20%';
    worksheet.mergeCells('O7', 'P7');
    worksheet.getCell('O8').value = 'Osnovica';
    worksheet.getCell('P8').value = 'Porez';

    worksheet.getCell('Q6').value = 'Oporezivo - obavljene el.usluge B2C unutar EU - SLO';
    worksheet.mergeCells('Q6', 'R6');
    worksheet.getCell('Q7').value = '22%';
    worksheet.mergeCells('Q7', 'R7');
    worksheet.getCell('Q8').value = 'Osnovica';
    worksheet.getCell('R8').value = 'Porez';

    worksheet.getCell('S6').value = 'Oporezivo';
    worksheet.mergeCells('S6', 'T6');
    worksheet.getCell('S7').value = '25%';
    worksheet.mergeCells('S7', 'T7');
    worksheet.getCell('S8').value = 'Osnovica';
    worksheet.getCell('T8').value = 'Porez';


    worksheet.getCell('U6').value = 'Način plaćanja';
    worksheet.mergeCells('U6', 'U8');
    worksheet.getCell('V6').value = 'Paypal plaćanje iznos EUR';
    worksheet.mergeCells('V6', 'V8');
    worksheet.getCell('W6').value = 'Vrsta kartice';
    worksheet.mergeCells('W6', 'W8');
    worksheet.getCell('X6').value = 'Vrsta usluge ';
    worksheet.mergeCells('X6', 'X8');
    worksheet.getCell('Y6').value = 'Komada usluge ';
    worksheet.mergeCells('Y6', 'Y8');

 // header styles 
    const headerCells = [ 'A6', 'B6', 'B7', 'C6', 'C7', 'D6', 'D7', 'E7', 
            'F7', 'G7', 'H7', 'I6', 'J6', 'K6', 'L6', 'L7', 'M7', 'N7', 'O6', 'O7', 'O8', 'P8', 'Q6',
            'Q7', 'Q8', 'R8', 'S6', 'T6', 'U6', 'V6', 'W6', 'X6', 'Y6', 'S8', 'T8', 'S7'];
   
    headerCells.map((data) => {
        worksheet.getCell(data).border = border;
        worksheet.getCell(data).alignment = alignment;

        return null;
    })
    
    const currencyFractionDigits = new Intl.NumberFormat('hr-HR', {
        style: 'currency',
        currency: 'EUR',
    }).resolvedOptions().maximumFractionDigits;

    data.map((data, index) => {        
        var broj = 9 + index;
        worksheet.getCell('A' + broj).border = border;
        worksheet.getCell('A' + broj).alignment = alignment;
        worksheet.getCell('A' + broj).value= data.ordinal_number;

        worksheet.getCell('B' + broj).border = border;
        worksheet.getCell('B' + broj).alignment = alignment;
        worksheet.getCell('B' + broj).value= data.receipt_number;

        worksheet.getCell('C' + broj).border = border;
        worksheet.getCell('C' + broj).alignment = alignment;
        worksheet.getCell('C' + broj).value= moment(data.created).format('DD.MM.YYYY') ;

        worksheet.getCell('D' + broj).border = border;
        worksheet.getCell('D' + broj).alignment = alignment;
        worksheet.getCell('D' + broj).value= data.customer_id;

        worksheet.getCell('E' + broj).border = border;
        worksheet.getCell('E' + broj).alignment = alignment;
        worksheet.getCell('E' + broj).value= data.customer_name;

        worksheet.getCell('F' + broj).border = border;
        worksheet.getCell('F' + broj).alignment = alignment;
       // worksheet.getCell('D' + broj).value= data.address;

        worksheet.getCell('G' + broj).border = border;
        worksheet.getCell('G' + broj).alignment = alignment;
        worksheet.getCell('G' + broj).value= data.country;

        worksheet.getCell('H' + broj).border = border;
        worksheet.getCell('H' + broj).alignment = alignment;
        worksheet.getCell('H' + broj).value= data.customer_oib;

        worksheet.getCell('I' + broj).border = border;
        worksheet.getCell('I' + broj).alignment = alignment;        
        worksheet.getCell('I' + broj).value= data.amount.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('J' + broj).border = border;
        worksheet.getCell('J' + broj).alignment = alignment;
        worksheet.getCell('J' + broj).value= data.currency_short;

        worksheet.getCell('K' + broj).border = border;
        worksheet.getCell('K' + broj).alignment = alignment;
        
        worksheet.getCell('K' + broj).value= data.ukupno_u_hrk.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('L' + broj).border = border;
        worksheet.getCell('L' + broj).alignment = alignment;
        //worksheet.getCell('L' + broj).value= data.;

        worksheet.getCell('M' + broj).border = border;
        worksheet.getCell('M' + broj).alignment = alignment;
        worksheet.getCell('M' + broj).value= data.osnovica_0.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('N' + broj).border = border;
        worksheet.getCell('N' + broj).alignment = alignment;
        //worksheet.getCell('N' + broj).value= data.;

        worksheet.getCell('O' + broj).border = border;
        worksheet.getCell('O' + broj).alignment = alignment;
        worksheet.getCell('O' + broj).value= data.osnovica_20.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('P' + broj).border = border;
        worksheet.getCell('P' + broj).alignment = alignment;
        worksheet.getCell('P' + broj).value= data.porez_20.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });


        worksheet.getCell('Q' + broj).border = border;
        worksheet.getCell('Q' + broj).alignment = alignment;
        worksheet.getCell('Q' + broj).value= data.osnovica_22.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('R' + broj).border = border;
        worksheet.getCell('R' + broj).alignment = alignment;
        worksheet.getCell('R' + broj).value= data.porez_22.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('S' + broj).border = border;
        worksheet.getCell('S' + broj).alignment = alignment;
        worksheet.getCell('S' + broj).value= data.osnovica_25.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('T' + broj).border = border;
        worksheet.getCell('T' + broj).alignment = alignment;
        worksheet.getCell('T' + broj).value= data.porez_25.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('U' + broj).border = border;
        worksheet.getCell('U' + broj).alignment = alignment;
        worksheet.getCell('U' + broj).value= data.payment_type;

        worksheet.getCell('V' + broj).border = border;
        worksheet.getCell('V' + broj).alignment = alignment;
        worksheet.getCell('V' + broj).value= data.paypal_eur.toLocaleString('de-DE', { maximumFractionDigits: currencyFractionDigits });

        worksheet.getCell('W' + broj).border = border;
        worksheet.getCell('W' + broj).alignment = alignment;
        worksheet.getCell('W' + broj).value= data.card;

        worksheet.getCell('X' + broj).border = border;
        worksheet.getCell('X' + broj).alignment = alignment;
        worksheet.getCell('X' + broj).value= data.item_code;

        worksheet.getCell('Y' + broj).border = border;
        worksheet.getCell('Y' + broj).alignment = alignment;
        worksheet.getCell('Y' + broj).value= data.item_quantity;

        return null;
    })

/*
     data.forEach(function(data, index) {
        let posProstorCell  = 'A' + (9 + index)
        let ISUCell  = 'B' + (6 + index)
        let gotovinaCell  = 'C' + (6 + index)
        let karticeCell = 'D' + (6 + index)
        let theRestAmountCell = 'E' + (6 + index)
        let totalAmountCell = 'F' + (6 + index)
        let osnovicaCell = 'G' + (6 + index)
        let PDVCell = 'H' + (6 + index)

        worksheet.getCell(posProstorCell).alignment = { vertical: 'middle', horizontal: 'center' }
        worksheet.getCell(ISUCell).alignment = { vertical: 'middle', horizontal: 'center' }
        worksheet.getCell(gotovinaCell).numFmt = '#,##0.00'
        worksheet.getCell(karticeCell).numFmt = '#,##0.00'
        worksheet.getCell(theRestAmountCell).numFmt = '#,##0.00'
        worksheet.getCell(totalAmountCell).numFmt = '#,##0.00'
        worksheet.getCell(totalAmountCell).font = { 'bold': true }
        worksheet.getCell(osnovicaCell).numFmt = '#,##0.00'
        worksheet.getCell(PDVCell).numFmt = '#,##0.00'
    })

    worksheet.getCell('C' + ( 6 + data.length)).numFmt = '#,##0.00'    
    worksheet.getCell('D' + ( 6 + data.length)).numFmt = '#,##0.00'
    worksheet.getCell('E' + ( 6 + data.length)).numFmt = '#,##0.00'
    worksheet.getCell('F' + ( 6 + data.length)).numFmt = '#,##0.00'
    worksheet.getCell('G' + ( 6 + data.length)).numFmt = '#,##0.00'
    worksheet.getCell('H' + ( 6 + data.length)).numFmt = '#,##0.00'

    // HEADER color
    worksheet.getCell('A5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('A5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('B5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('B5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('C5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('C5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('D5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('D5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('E5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('E5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('F5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('F5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('G5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('G5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('H5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('H5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('I5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('I5').font = {color: {argb: "FFFFFF"}};

    */
        
    
    /*worksheet.getCell('A5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('B5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('C5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('D5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('E5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('F5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('G5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('H5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };*/
/*
    const row = worksheet.getRow(5);
    row.height = 50;
    row.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
*/
    worksheet.columns = [
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 }
    ];

    /*
    dobCol.header = [
        {header:'OZNAKA POSLOVNOG PROSTORA',key:'ozn'  ,width: 10}, //i need something like startRow:2
          {header:'ISU',key:'ISU'  ,width: 10},
          {header:'GOTOVINA - G',key:'got'  ,width: 10}
        ];
        
       
/*
    worksheet.columns = [
    {header: 'OZNAKA POSLOVNOG PROSTORA', key: 'ozn', width: 10},
    {header: 'ISU', key: 'ISU', width: 10}, 
    {header: 'GOTOVINA', key: 'got', width: 10,}
    ];
    
    worksheet.addRow({ozn: 1, ISU: 'John Doe', got: 0 });
    */
    // save under export.xlsx
    const buffer = await workbook.xlsx.writeBuffer(options);
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const fileExtension = '.xlsx';
    
    const blob = new Blob([buffer], {type: fileType});

    saveAs(blob, 'Izvjestaj' + fileExtension);
}